import { Logger } from './logger';

/**
 * 검증 유틸리티 클래스
 */
export class ValidationUtils {
  /**
   * 프로젝트 이름 검증
   */
  public static validateProjectName(name: string): boolean {
    const validNameRegex = /^[a-z0-9-_]+$/;
    
    if (!name) {
      Logger.error('프로젝트 이름이 필요합니다.');
      return false;
    }

    if (name.length < 2) {
      Logger.error('프로젝트 이름은 최소 2자 이상이어야 합니다.');
      return false;
    }

    if (name.length > 50) {
      Logger.error('프로젝트 이름은 최대 50자까지 가능합니다.');
      return false;
    }

    if (!validNameRegex.test(name)) {
      Logger.error('프로젝트 이름은 소문자, 숫자, 하이픈(-), 언더스코어(_)만 사용 가능합니다.');
      return false;
    }

    if (name.startsWith('-') || name.endsWith('-')) {
      Logger.error('프로젝트 이름은 하이픈(-)으로 시작하거나 끝날 수 없습니다.');
      return false;
    }

    return true;
  }

  /**
   * 포트 번호 검증
   */
  public static validatePort(port: string): boolean {
    const portNumber = parseInt(port, 10);

    if (isNaN(portNumber)) {
      Logger.error('포트 번호는 숫자여야 합니다.');
      return false;
    }

    if (portNumber < 1 || portNumber > 65535) {
      Logger.error('포트 번호는 1-65535 범위여야 합니다.');
      return false;
    }

    if (portNumber < 1024) {
      Logger.warning('1024 미만의 포트는 관리자 권한이 필요할 수 있습니다.');
    }

    return true;
  }

  /**
   * 호스트 주소 검증
   */
  public static validateHost(host: string): boolean {
    if (!host) {
      Logger.error('호스트 주소가 필요합니다.');
      return false;
    }

    // Basic hostname validation
    const hostnameRegex = /^[a-zA-Z0-9.-]+$/;
    
    if (!hostnameRegex.test(host)) {
      Logger.error('올바르지 않은 호스트 주소 형식입니다.');
      return false;
    }

    return true;
  }

  /**
   * 파일 경로 검증
   */
  public static validateFilePath(filePath: string): boolean {
    if (!filePath) {
      Logger.error('파일 경로가 필요합니다.');
      return false;
    }

    // Check for invalid characters
    const invalidChars = /[<>:"|?*]/;
    
    if (invalidChars.test(filePath)) {
      Logger.error('파일 경로에 올바르지 않은 문자가 포함되어 있습니다.');
      return false;
    }

    return true;
  }

  /**
   * 재생 속도 검증
   */
  public static validateSpeed(speed: string): boolean {
    const speedNumber = parseFloat(speed);

    if (isNaN(speedNumber)) {
      Logger.error('재생 속도는 숫자여야 합니다.');
      return false;
    }

    if (speedNumber <= 0) {
      Logger.error('재생 속도는 0보다 커야 합니다.');
      return false;
    }

    if (speedNumber > 10) {
      Logger.warning('재생 속도가 너무 빠를 수 있습니다.');
    }

    return true;
  }

  /**
   * 시간 검증 (초 단위)
   */
  public static validateDuration(duration: string): boolean {
    const durationNumber = parseInt(duration, 10);

    if (isNaN(durationNumber)) {
      Logger.error('시간은 숫자여야 합니다.');
      return false;
    }

    if (durationNumber <= 0) {
      Logger.error('시간은 0보다 커야 합니다.');
      return false;
    }

    if (durationNumber > 3600) {
      Logger.warning('기록 시간이 1시간을 초과합니다.');
    }

    return true;
  }
}
